"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductTabs = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ProductImagesGallery = _interopRequireDefault(require("../ProductImagesGallery/ProductImagesGallery"));

var _DescriptionTab = _interopRequireDefault(require("../DescriptionTab/DescriptionTab"));

var _NumberFormat = _interopRequireDefault(require("../../NumberFormat"));

var _Buttons = require("../../Buttons");

var _Icon = require("../../Icon");

var ProductTabs;
exports.ProductTabs = ProductTabs;

(function (ProductTabs) {
  ProductTabs["description"] = "Description";
  ProductTabs["details"] = "Details";
})(ProductTabs || (exports.ProductTabs = ProductTabs = {}));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    title: {
      fontSize: 24,
      lineHeight: 1.33,
      color: palette.text.primary
    },
    subTitle: {
      fontSize: 16,
      lineHeight: 1.5,
      color: palette.grey.main
    },
    merchantLink: {
      color: palette.link.main,
      cursor: 'pointer'
    }
  };
});

var Product = function Product(_ref2) {
  var _product$images, _product$description;

  var product = _ref2.product,
      children = _ref2.children,
      onShowMerchant = _ref2.onShowMerchant,
      onAddProduct = _ref2.onAddProduct,
      onRemoveProduct = _ref2.onRemoveProduct,
      onToggleTab = _ref2.onToggleTab,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$wrapperProps = _ref2.wrapperProps,
      wrapperProps = _ref2$wrapperProps === void 0 ? {} : _ref2$wrapperProps,
      _ref2$overrideClasses = _ref2.overrideClasses,
      overrideClasses = _ref2$overrideClasses === void 0 ? {} : _ref2$overrideClasses;
  var classes = useStyles();

  var _useState = (0, _react.useState)(ProductTabs.description || false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      openTab = _useState2[0],
      setOpenTab = _useState2[1];

  var handleToggleTab = (0, _react.useCallback)(function (tab) {
    var newOpenTab = tab === openTab ? false : tab;
    setOpenTab(newOpenTab);

    if (!newOpenTab) {
      onToggleTab && onToggleTab(tab);
    }
  }, [openTab, onToggleTab]);

  var handleAddProduct = function handleAddProduct() {
    onAddProduct && product && onAddProduct(product.id);
  };

  var handleRemoveProduct = function handleRemoveProduct() {
    onRemoveProduct && product && onRemoveProduct(product.id);
  };

  var getTabIcon = (0, _react.useCallback)(function (tab) {
    return tab === openTab ? 'angle-up' : 'angle-down';
  }, [openTab]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    className: (0, _classnames["default"])('productDetailsWrapper-ie', {
      'productDetailsWrapperWithOptions-ie': !!(product !== null && product !== void 0 && product.options)
    }),
    width: 1,
    px: 3,
    py: 0
  }, wrapperProps), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    mt: 2,
    mb: 1,
    textAlign: "left"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: classes.title
  }, (product === null || product === void 0 ? void 0 : product.localPrice) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, product.localPrice.currencySign, /*#__PURE__*/_react["default"].createElement(_NumberFormat["default"], {
    format: "0,0"
  }, product.localPrice.price)), ' ', product === null || product === void 0 ? void 0 : product.name), !(product !== null && product !== void 0 && product.hasExternalFulfillment) && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: classes.subTitle
  }, "from", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    role: "link",
    tabIndex: 0,
    onClick: onShowMerchant,
    onKeyDown: onShowMerchant,
    className: (0, _classnames["default"])(classes.merchantLink, overrideClasses.merchantLink)
  }, product === null || product === void 0 ? void 0 : product.provider.name))), /*#__PURE__*/_react["default"].createElement(_ProductImagesGallery["default"], {
    images: (_product$images = product === null || product === void 0 ? void 0 : product.images) !== null && _product$images !== void 0 ? _product$images : [],
    isTangoCard: product === null || product === void 0 ? void 0 : product.isTangoCard,
    overrideClasses: overrideClasses
  }), (onAddProduct || onRemoveProduct) && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    my: 3,
    display: "flex",
    justifyContent: "center"
  }, onAddProduct && /*#__PURE__*/_react["default"].createElement(_Buttons.Button, {
    onClick: handleAddProduct,
    disabled: disabled,
    color: "primary",
    startIcon: /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: "plus"
    })
  }, "Add to Marketplace"), onRemoveProduct && /*#__PURE__*/_react["default"].createElement(_Buttons.Button, {
    onClick: handleRemoveProduct,
    disabled: disabled,
    borderColor: "divider",
    startIcon: /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: "minus"
    })
  }, "Remove from Marketplace")), /*#__PURE__*/_react["default"].createElement(_DescriptionTab["default"], {
    title: ProductTabs.description,
    isOpen: openTab === ProductTabs.description,
    toggleOpen: function toggleOpen() {
      return handleToggleTab(ProductTabs.description);
    },
    content: (_product$description = product === null || product === void 0 ? void 0 : product.description) !== null && _product$description !== void 0 ? _product$description : ''
  }), (product === null || product === void 0 ? void 0 : product.specialDescription) && /*#__PURE__*/_react["default"].createElement(_DescriptionTab["default"], {
    title: ProductTabs.details,
    icon: getTabIcon(ProductTabs.details),
    isOpen: openTab === ProductTabs.details,
    toggleOpen: function toggleOpen() {
      return handleToggleTab(ProductTabs.details);
    },
    content: product === null || product === void 0 ? void 0 : product.specialDescription
  })), children);
};

var _default = /*#__PURE__*/(0, _react.memo)(Product);

exports["default"] = _default;